// @flow

import universal from 'react-universal-component';

export default universal(import('SplatRouter/component'));



// WEBPACK FOOTER //
// ./screens/SplatRouter/index.js